<template>
    <v-card flat color="grey-f1" rounded="lg" class="py-16 px-24">
        <p class="page--text text-center primary--text">
            <template v-if="value?.employer?.interview?.isOnline">
                <span> 온라인 면접 </span>
            </template>
            <template v-else>
                <span> 면접장소: {{ value?.employer?.interview?.location }} </span>
            </template>
        </p>
    </v-card>
</template>

<script>
import { initExpoMatching } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initExpoMatching },
    },
};
</script>

<style>
</style>